import React from "react"
import { hydrate } from "react-dom"
import { BrowserRouter } from "react-router-dom"

import { ApolloClient } from "apollo-client"
import { ApolloProvider } from "react-apollo"
import { from } from "apollo-link"
import { InMemoryCache } from "apollo-cache-inmemory"
import ErrorBoundary from "./components/ErrorBoundary"
import ErrorScreen from "./views/ErrorScreen"

import { errorLink, queryOrMutationLink } from "./links"

import App from "./routes/App"

import { fragmentMatcher } from "./fragmentMatcher"

const links = [errorLink, queryOrMutationLink()]

const pageClientErrorHandler = (error, location) => {
  try {
    let cleanError =
      error.message &&
      JSON.parse(error.message.replace(/^(Error: )*GraphQL error: /gi, ""))

    if (
      cleanError &&
      cleanError.redirect_url === location.path + location.search
    ) {
      return null
    }

    if (
      cleanError &&
      cleanError.http_status_code === 301 &&
      cleanError.redirect_url
    ) {
      window.location.replace(cleanError.redirect_url)
    }

    if (
      cleanError &&
      cleanError.http_status_code === 403 &&
      cleanError.redirect_url
    ) {
      window.location.replace(cleanError.redirect_url)
    }

    if (cleanError.http_status_code === 404) {
      return (
        <div id="main-container">
          <ErrorScreen error={error} message="404" />
        </div>
      )
    }

    if (
      cleanError &&
      cleanError.http_status_code === 302 &&
      cleanError.redirect_url
    ) {
      let redirect_url = `/login?redirect_url=${cleanError.redirect_url}`
      //RT: 302 page is found but needs to redirect for the user to be login.
      window.location.replace(redirect_url)
    }
  } catch (e) {
    console.log(e)
    return (
      <div id="main-container">
        <ErrorScreen error={error} message="Internal Server Error" />
      </div>
    )
  }
}

const client = new ApolloClient({
  ssrForceFetchDelay: 100,
  link: from(links),
  connectToDevTools: true,
  // here we're initializing the cache with the data from the server's cache
  cache: new InMemoryCache({ fragmentMatcher }).restore(
    window.__APOLLO_STATE__
  ),
})

hydrate(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <ErrorBoundary
        component={(props) => {
          return pageClientErrorHandler(props.error, props.location)
        }}
      >
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("content")
)
